import { Fragment } from 'react';
import NSToken from '@connectedhomes/nucleus/tokens/font.json';

type WrapTextProps = {
  children: string;
  wrap?: boolean;
  max?: number;
};

export const WrapText = ({
  children,
  wrap = false,
  max = parseInt(NSToken.font.lineLength.value, 10)
}: WrapTextProps) => {
  if (!wrap) {
    return children;
  }

  const parsedChildren = Array.isArray(children) ? children.join('') : children;

  return parsedChildren
    .split(/\s+/)
    .reduce<string[]>((acc, word) => {
      if (acc.length === 0) {
        return [word];
      }
      const lastLine = acc[acc.length - 1];
      if ((lastLine + ' ' + word).length <= max) {
        acc[acc.length - 1] = lastLine + ' ' + word;
      } else {
        acc.push(word);
      }
      return acc;
    }, [])
    .map((line, lineIndex) => (
      <Fragment key={lineIndex}>
        {lineIndex !== 0 && <br />}
        {line}
      </Fragment>
    ));
};
